import React from 'react';
import styled from 'styled-components';
import LegalPageLayout, { LegalSection, LegalSubtitle, LegalText, LegalList } from '../../components/LegalPageLayout';

const CookieTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 2rem;
  
  th, td {
    border: 1px solid #ddd;
    padding: 0.75rem;
    text-align: left;
  }
  
  th {
    background-color: #f8f9fa;
    font-weight: 600;
  }
  
  tr:nth-child(even) {
    background-color: #f8f9fa;
  }
`;

const CookiesPage = () => {
  return (
    <LegalPageLayout
      title="Política de Cookies"
      description="Política de cookies de Web a Bajo Coste. Información sobre el uso de cookies y tecnologías similares en nuestro sitio web."
      canonical="https://webabajocoste.es/legal/cookies"
    >
      <LegalSection>
        <LegalSubtitle>1. ¿Qué son las cookies?</LegalSubtitle>
        <LegalText>
          Las cookies son pequeños archivos de texto que se almacenan en su dispositivo (ordenador, tablet, smartphone) 
          cuando visita un sitio web. Las cookies ayudan al sitio web a recordar información sobre su visita, 
          como su idioma preferido y otras configuraciones, lo que puede facilitar su próxima visita y hacer que el 
          sitio le resulte más útil.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>2. ¿Quién es el responsable del uso de cookies?</LegalSubtitle>
        <LegalText>
          El responsable del tratamiento de los datos obtenidos mediante el uso de cookies en este sitio web es:
        </LegalText>
        <LegalList>
          <li>Denominación social: Candle Dropstore Sociedad Limitada</li>
          <li>CIF: B19327030</li>
          <li>Domicilio social: Calle Merced 20 1C, Guadalajara 19001, España</li>
          <li>Teléfono: +34 628 774 688</li>
          <li>Email: hola@webabajocoste.es</li>
        </LegalList>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>3. Tipos de cookies que utilizamos</LegalSubtitle>
        <LegalText>
          Según su finalidad, las cookies que utilizamos se clasifican en:
        </LegalText>
        
        <LegalSubtitle style={{ fontSize: '1.3rem', marginTop: '1.5rem' }}>Cookies técnicas</LegalSubtitle>
        <LegalText>
          Son aquellas que permiten al usuario la navegación a través de la página web y la utilización de las 
          diferentes opciones o servicios que en ella existen. Por ejemplo, controlar el tráfico y la comunicación 
          de datos, identificar la sesión, acceder a partes de acceso restringido, recordar los elementos que integran 
          un pedido, realizar el proceso de compra de un pedido, gestionar el pago, etc.
        </LegalText>
        
        <LegalSubtitle style={{ fontSize: '1.3rem', marginTop: '1.5rem' }}>Cookies de análisis</LegalSubtitle>
        <LegalText>
          Son aquellas que permiten al responsable de las mismas, el seguimiento y análisis del comportamiento de los 
          usuarios de los sitios web a los que están vinculadas. La información recogida mediante este tipo de cookies 
          se utiliza en la medición de la actividad de los sitios web, aplicación o plataforma y para la elaboración de 
          perfiles de navegación de los usuarios de dichos sitios, con el fin de introducir mejoras en función del análisis 
          de los datos de uso que hacen los usuarios del servicio.
        </LegalText>
        
        <LegalSubtitle style={{ fontSize: '1.3rem', marginTop: '1.5rem' }}>Cookies de publicidad</LegalSubtitle>
        <LegalText>
          Son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, 
          el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado en base 
          a criterios como el contenido editado o la frecuencia en la que se muestran los anuncios.
        </LegalText>
        
        <LegalSubtitle style={{ fontSize: '1.3rem', marginTop: '1.5rem' }}>Cookies de publicidad comportamental</LegalSubtitle>
        <LegalText>
          Son aquellas que permiten la gestión, de la forma más eficaz posible, de los espacios publicitarios que, en su caso, 
          el editor haya incluido en una página web, aplicación o plataforma desde la que presta el servicio solicitado. Estas 
          cookies almacenan información del comportamiento de los usuarios obtenida a través de la observación continuada de sus 
          hábitos de navegación, lo que permite desarrollar un perfil específico para mostrar publicidad en función del mismo.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>4. Detalle de las cookies utilizadas</LegalSubtitle>
        <LegalText>
          A continuación, le informamos detalladamente de las cookies que pueden instalarse en su navegador:
        </LegalText>
        
        <CookieTable>
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Tipo</th>
              <th>Propósito</th>
              <th>Duración</th>
              <th>Proveedor</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>_ga</td>
              <td>Análisis</td>
              <td>Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web.</td>
              <td>2 años</td>
              <td>Google Analytics</td>
            </tr>
            <tr>
              <td>_gid</td>
              <td>Análisis</td>
              <td>Registra una identificación única que se utiliza para generar datos estadísticos acerca de cómo utiliza el visitante el sitio web.</td>
              <td>24 horas</td>
              <td>Google Analytics</td>
            </tr>
            <tr>
              <td>_gat</td>
              <td>Análisis</td>
              <td>Se utiliza para limitar la tasa de peticiones.</td>
              <td>1 minuto</td>
              <td>Google Analytics</td>
            </tr>
            <tr>
              <td>cookieconsent_status</td>
              <td>Técnica</td>
              <td>Almacena el estado de consentimiento de cookies del usuario para el dominio actual.</td>
              <td>1 año</td>
              <td>Propio</td>
            </tr>
          </tbody>
        </CookieTable>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>5. ¿Cómo gestionar y desactivar las cookies?</LegalSubtitle>
        <LegalText>
          Usted puede permitir, bloquear o eliminar las cookies instaladas en su equipo mediante la configuración de las 
          opciones de su navegador. A continuación, puede encontrar información sobre cómo hacerlo en los navegadores más populares:
        </LegalText>
        <LegalList>
          <li><a href="https://support.google.com/chrome/answer/95647?hl=es" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
          <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
          <li><a href="https://support.microsoft.com/es-es/microsoft-edge/eliminar-las-cookies-en-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
        </LegalList>
        <LegalText>
          Si desactiva las cookies, es posible que algunas de las funcionalidades de la web no estén disponibles.
        </LegalText>
      </LegalSection>
      
      <LegalSection>
        <LegalSubtitle>6. Cambios en la política de cookies</LegalSubtitle>
        <LegalText>
          Es posible que actualicemos la Política de Cookies de nuestro sitio web, por ello le recomendamos revisar esta 
          política cada vez que acceda a nuestro sitio web con el objetivo de estar adecuadamente informado sobre cómo y 
          para qué usamos las cookies.
        </LegalText>
      </LegalSection>
      
      <LegalText>
        Fecha de la última actualización: 28 de marzo de 2023
      </LegalText>
    </LegalPageLayout>
  );
};

export default CookiesPage; 